module.exports = __webpack_public_path__ + "4a37f8008959c75f619bf0a3a4e2d7a2.png";


//////////////////
// WEBPACK FOOTER
// ./~/owl.carousel/dist/assets/owl.video.play.png
// module id = 17
// module chunks = 0